/**
 * 设置cookie
 * @param {String} cname
 * @param {String} cvalue
 * @param {Number} exdays
 * @param {String} path
 * @param {String} domain
 */
export function setCookie(cname, cvalue, exdays, path, domain) {
  var expires;
  var d = new Date();
  path = path || '/';
  cname = path === '/' ? cname : cname + path.replace('/', '_');
  if (exdays) {
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = 'expires=' + d.toUTCString();
  }
  exdays &&
    (document.cookie =
      cname + '=' + cvalue + '; ' + expires + ';path=/' + ';domain=' + domain);
  !exdays &&
    (document.cookie = cname + '=' + cvalue + ';path=/' + ';domain=' + domain);
}

/**
 * 获取cookie
 * @param {String} cname
 * @param {String} path
 * @returns {string}
 */
export function getCookie(cname, path) {
  path = path || '/';
  cname = path === '/' ? cname : cname + path.replace('/', '_');
  var value = '';
  if (document.cookie.length > 0) {
    var arr = document.cookie.split(';');
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].split('=')[0].trim() === cname) {
        value = arr[i].split('=')[1];
      }
    }
  }
  return value;
}
